import { useQuery } from '@tanstack/react-query';

import { companySourcesApi } from 'api/inventory/companySources';

export const COMPANY_SOURCES_QUERY_KEY = 'companySources';

export const companySourcesQueryKeys = {
    all: [COMPANY_SOURCES_QUERY_KEY],
    list: (procurement) => [COMPANY_SOURCES_QUERY_KEY, { procurement }],
};

/**
 * @param {Array<{id: number, code: string, displayName: string}>} companySources
 * @returns {Array<{value: number, label: string, code: string}>}
 */
export function mapCompanySourcesToOptions(companySources) {
    return companySources.map((source) => ({
        value: source.id,
        label: source.displayName,
        code: source.code,
    }));
}

/**
 * Fetches active company sources.
 *
 * @param {Object} [options]
 * @param {boolean} [options.enabled=true]
 * @param {boolean} [options.procurement=false] - Restricts results to MM, BA, and MS.
 */
export function useCompanySourcesQuery({ enabled = true, procurement = false } = {}) {
    return useQuery({
        enabled,
        gcTime: 30 * 60_000,
        queryFn: async ({ signal }) => {
            const response = await companySourcesApi.getCompanySources({ procurement, signal });
            if (!response?.status) {
                throw new Error(response?.msg ?? 'Failed to fetch company sources');
            }
            return Array.isArray(response?.data?.companySources) ? response.data.companySources : [];
        },
        queryKey: companySourcesQueryKeys.list(procurement),
        staleTime: 15 * 60_000,
    });
}
